import { Component, ojs, app, v } from "modular-openscriptjs";
import {
    pageInfo,
    formatThousand,
    scrollToTop,
    openModal,
} from "../../../helpers";
import { PAGES, uc } from "../../../declarations";
import DepositAiCreditForm from "../../Forms/DepositAiCreditForm";
import Modal from "../../Blocks/Modal";

const h = app("h");

ojs(DepositAiCreditForm, Modal);

export default class AiCreditWallet extends Component {
    render(...args) {
        pageInfo(PAGES.AI_CREDITS);
        scrollToTop();

        return h.div(
            { class: "py-5 min-vh-100 mb-5 py-md-5" },
            h.div(
                { class: "container" },
                // Header Section
                h.div(
                    { class: "mb-5 text-center mt-3" },
                    h.div(
                        {
                            class: "d-inline-flex align-items-center gap-2 px-3 py-1 border rounded-pill shadow-sm mb-3 ai-float bg-white",
                        },
                        h.i({ class: "bi bi-stars text-warning fs-5" }),
                        h.span({ class: "fw-bold text-dark" }, "AI Power Hub"),
                    ),
                    h.h1(
                        { class: "fw-bold display-5 mb-3" },
                        h.span({ class: "text-dark" }, "Your AI "),
                        h.span(
                            {
                                style: "background: linear-gradient(to right, #d49a2a, #973e87); -webkit-background-clip: text; -webkit-text-fill-color: transparent;",
                            },
                            "Credits",
                        ),
                    ),
                    h.p(
                        {
                            class: "text-secondary fs-5 mx-auto",
                            style: "max-width: 600px;",
                        },
                        "Our AI runs your shop online for you.",
                    ),
                ),

                h.div(
                    { class: "row justify-content-center g-4" },
                    // Balance Card
                    h.div(
                        { class: "col-lg-5 col-md-6" },
                        h.div(
                            {
                                class: "card border-0 rounded-4 shadow-lg ai-gradient-bg text-white h-100 overflow-hidden position-relative hover-scale",
                                style: "min-height: 200px;",
                            },
                            // Decorative circles
                            h.div({
                                class: "position-absolute rounded-circle",
                                style: "width: 200px; height: 200px; background: rgba(255,255,255,0.08); top: -40px; right: -40px; filter: blur(5px);",
                            }),
                            h.div({
                                class: "position-absolute rounded-circle",
                                style: "width: 300px; height: 300px; background: rgba(255,255,255,0.05); bottom: -120px; left: -80px; filter: blur(3px);",
                            }),

                            h.div(
                                {
                                    class: "card-body p-4 p-md-4 d-flex flex-column position-relative z-1",
                                },
                                h.div(
                                    {
                                        class: "d-flex justify-content-between align-items-start mb-auto",
                                    },
                                    h.div(
                                        h.h6(
                                            {
                                                class: "text-white opacity-75 fw-semibold text-uppercase mb-3",
                                                style: "font-size: 0.85rem; letter-spacing: 1.5px;",
                                            },
                                            "Available Balance",
                                        ),
                                        v(uc.aiCredit, (wallet) =>
                                            h.h1(
                                                {
                                                    class: "fw-bold mb-0 display-4",
                                                },
                                                formatThousand(
                                                    wallet.value?.balance ?? 0,
                                                ),
                                                h.span(
                                                    {
                                                        class: "fs-5 fw-normal opacity-75 ms-2",
                                                    },
                                                    "Credits",
                                                ),
                                            ),
                                        ),
                                    ),
                                    h.div(
                                        {
                                            class: "glass-panel rounded-circle d-flex align-items-center justify-content-center shadow ai-float",
                                            style: "width: 56px; height: 56px;",
                                        },
                                        h.i({
                                            class: "bi bi-lightning-charge-fill fs-3 text-white",
                                        }),
                                    ),
                                ),
                                h.button(
                                    {
                                        class: "btn btn-light w-100 rounded-pill fw-bold py-3 mt-4 shadow text-primary border-0",
                                        style: "font-size: 1.1rem; transition: all 0.2s; background: white;",
                                        onmouseover:
                                            "this.style.transform='scale(1.02)';",
                                        onmouseout:
                                            "this.style.transform='scale(1)';",
                                        listeners: {
                                            click: () => {
                                                openModal(`deposit-ai-credit-modal`);
                                            },
                                        },
                                    },
                                    h.i({
                                        class: "bi bi-plus-circle-fill me-2",
                                    }),
                                    "Buy AI Credits",
                                ),
                            ),
                        ),
                    ),

                    // Info/Features Column
                    h.div(
                        { class: "col-lg-5 col-md-6" },
                        h.div(
                            { class: "d-flex flex-column gap-3 h-100" },

                            // Feature 1
                            h.div(
                                {
                                    class: "card border border-light rounded-4 shadow-sm feature-card h-100",
                                },
                                h.div(
                                    {
                                        class: "card-body p-4 d-flex align-items-center gap-4",
                                    },
                                    h.div(
                                        {
                                            class: "feature-icon-wrapper flex-shrink-0",
                                        },
                                        h.i({ class: "bi bi-cloud-arrow-up-fill fs-4" }),
                                    ),
                                    h.div(
                                        h.h6(
                                            { class: "fw-bold mb-1 text-dark" },
                                            "Product Upload",
                                        ),
                                        h.p(
                                            {
                                                class: "text-muted mb-0 small fw-medium",
                                            },
                                            "Upload a simple image or menu and your products are automatically added, titled, and formatted for customers to browse.",
                                        ),
                                    ),
                                ),
                            ),

                            // Feature 2
                            h.div(
                                {
                                    class: "card border border-light rounded-4 shadow-sm feature-card h-100",
                                },
                                h.div(
                                    {
                                        class: "card-body p-4 d-flex align-items-center gap-4",
                                    },
                                    h.div(
                                        {
                                            class: "feature-icon-wrapper flex-shrink-0",
                                        },
                                        h.i({
                                            class: "bi bi-diagram-3-fill fs-4",
                                        }),
                                    ),
                                    h.div(
                                        h.h6(
                                            { class: "fw-bold mb-1 text-dark" },
                                            "Organized Storefront",
                                        ),
                                        h.p(
                                            {
                                                class: "text-muted mb-0 small fw-medium",
                                            },
                                            "Your products are automatically categorized so customers can find what they want instantly without confusion.",
                                        ),
                                    ),
                                ),
                            ),

                            // Feature 3
                            h.div(
                                {
                                    class: "card border border-light rounded-4 shadow-sm feature-card h-100",
                                },
                                h.div(
                                    {
                                        class: "card-body p-4 d-flex align-items-center gap-4",
                                    },
                                    h.div(
                                        {
                                            class: "feature-icon-wrapper flex-shrink-0",
                                        },
                                        h.i({ class: "bi bi-image-fill fs-4" }),
                                    ),
                                    h.div(
                                        h.h6(
                                            { class: "fw-bold mb-1 text-dark" },
                                            "High-Quality Product Images",
                                        ),
                                        h.p(
                                            {
                                                class: "text-muted mb-0 small fw-medium",
                                            },
                                            "Get clear, appealing product pictures generated for your items so your page looks professional without extra effort.",
                                        ),
                                    ),
                                ),
                            ),

                            // Feature 4
                            h.div(
                                {
                                    class: "card border border-light rounded-4 shadow-sm feature-card h-100",
                                },
                                h.div(
                                    {
                                        class: "card-body p-4 d-flex align-items-center gap-4",
                                    },
                                    h.div(
                                        {
                                            class: "feature-icon-wrapper flex-shrink-0",
                                        },
                                        h.i({ class: "bi bi-card-list fs-4" }),
                                    ),
                                    h.div(
                                        h.h6(
                                            { class: "fw-bold mb-1 text-dark" },
                                            "Menu to Digital",
                                        ),
                                        h.p(
                                            {
                                                class: "text-muted mb-0 small fw-medium",
                                            },
                                            "Take a picture of your menu and it is turned into a fully structured, easy-to-read digital menu with images included.",
                                        ),
                                    ),
                                ),
                            ),

                            // Feature 5
                            h.div(
                                {
                                    class: "card border border-light rounded-4 shadow-sm feature-card h-100",
                                },
                                h.div(
                                    {
                                        class: "card-body p-4 d-flex align-items-center gap-4",
                                    },
                                    h.div(
                                        {
                                            class: "feature-icon-wrapper flex-shrink-0",
                                        },
                                        h.i({ class: "bi bi-arrow-repeat fs-4" }),
                                    ),
                                    h.div(
                                        h.h6(
                                            { class: "fw-bold mb-1 text-dark" },
                                            "Always Up-to-Date Page",
                                        ),
                                        h.p(
                                            {
                                                class: "text-muted mb-0 small fw-medium",
                                            },
                                            "Your business page stays active and organized without you having to constantly update or fix anything.",
                                        ),
                                    ),
                                ),
                            ),
                        ),
                    ),
                ),
            ),
            h.Modal(
                {
                    id: `deposit-ai-credit-modal`,
                    title: "Buy AI Credits",
                    center: true,
                    bottom: false,
                    fullscreen: false,
                    footer: null,
                },
                h.DepositAiCreditForm(),
            ),
            ...args,
        );
    }
}

ojs(AiCreditWallet);
